import actions from './constants';
import * as serviceUtils from '../services/utils';

export const updateLoading = (data) => {
    return {
        type: actions.UPDATE_LOADING,
        payload: data
    }
};

export const updateUserInfo = (data) => {
    return {
        type: actions.UPDATE_USER_INFO,
        payload: data
    }
};

export const updateUserMeters = (data) =>{
    return {
        type: actions.UPDATE_USER_METERS,
        payload: data
    }  
}

export const showErrorMessage = (data) => {
    return {
        type: actions.SHOW_ERROR_MESSAGE,
        payload: data
    }
};

export const showSuccessMessage = (data) =>{
    return {
        type: actions.SHOW_SUCCESS_MESSAGE,
        payload: data
    }
}

export const logout = () =>{
    serviceUtils.removeToken();
    return {
        type : actions.LOGOUT
    }
}

export const setAccessToken = (token) =>{
    serviceUtils.setToken(token);
    return { type: actions.SET_ACCESS_TOKEN};
}
